<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.announcements', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.store" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-6 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.title')" for="title" />
                            <FormInput
                                required
                                id="title"
                                v-model.trim="form.title"
                                name="title"
                                type="text"
                                max="60"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.title" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-3">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.published_at')" for="published_at" />
                            <FormInput
                                required
                                id="published_at"
                                v-model="form.published_at"
                                name="published_at"
                                type="date"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.published_at" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-3">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.unpublished_at')" for="unpublished_at" />
                            <FormInput
                                required
                                id="unpublished_at"
                                v-model="form.unpublished_at"
                                name="unpublished_at"
                                type="date"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.unpublished_at" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.body')" for="body" />
                            <Editor id="body" v-model="form.body" name="body" class="mt-2" />
                            <FormError :value="form.errors.body" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import Editor from '@/components/Forms/RichTextEditor/Editor.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
        Editor,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                title: '',
                body: '',
                published_at: '',
                unpublished_at: '',
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
